module.exports = __webpack_public_path__ + "video/3500_CT_2022_Humans-and-Tech.4b5cb3f4.vtt";